export enum statusTypes {
    all = -1,
    unknown = 0,
    failsafe = 1,
    busy = 2,
    printing = 3,
    idle = 4,
    blackout = 5,
    offline = 6,
    unavailable = 7
}
